var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.feedingProgramDetailDeleteErrors },
        on: {
          "update:errors": function($event) {
            _vm.feedingProgramDetailDeleteErrors = $event
          }
        }
      }),
      _c("base-snackbar", {
        attrs: { errors: _vm.feedingProgramDetailGetErrors },
        on: {
          "update:errors": function($event) {
            _vm.feedingProgramDetailGetErrors = $event
          }
        }
      }),
      _c("v-data-table", {
        attrs: {
          items: _vm.feedingProgramDetailList,
          headers: _vm.headers,
          loading: _vm.feedingProgramDetailGetting,
          dense: ""
        },
        scopedSlots: _vm._u([
          {
            key: "item",
            fn: function({ item }) {
              return [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(item.day))]),
                  _c("td", [
                    _vm._v(
                      _vm._s((item.feed_per_day_kg || 0).unitFormat("kilogram"))
                    )
                  ]),
                  _c(
                    "td",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "yellow darken-3",
                            dense: "",
                            text: "",
                            "x-small": ""
                          },
                          on: {
                            click: function($event) {
                              return _vm.$emit("edit", item)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-pencil")])],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            dense: "",
                            text: "",
                            "x-small": "",
                            loading: _vm.feedingProgramDetailDeleting
                          },
                          on: {
                            click: function($event) {
                              return _vm.removeItem(item.id)
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("mdi-delete")])],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }